var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69334 13.0133C3.28667 13.0133 2.90667 12.8733 2.63334 12.6133C2.28667 12.2867 2.12001 11.7933 2.18001 11.26L2.42667 9.09999C2.47334 8.69333 2.72001 8.15333 3.00667 7.85999L8.48001 2.06666C9.84667 0.619992 11.2733 0.579992 12.72 1.94666C14.1667 3.31333 14.2067 4.73999 12.84 6.18666L7.36667 11.98C7.08667 12.28 6.56667 12.56 6.16001 12.6267L4.01334 12.9933C3.90001 13 3.80001 13.0133 3.69334 13.0133ZM10.62 1.93999C10.1067 1.93999 9.66001 2.25999 9.20667 2.73999L3.73334 8.53999C3.60001 8.67999 3.44667 9.01333 3.42001 9.20666L3.17334 11.3667C3.14667 11.5867 3.20001 11.7667 3.32001 11.88C3.44001 11.9933 3.62001 12.0333 3.84001 12L5.98667 11.6333C6.18001 11.6 6.50001 11.4267 6.63334 11.2867L12.1067 5.49333C12.9333 4.61333 13.2333 3.79999 12.0267 2.66666C11.4933 2.15333 11.0333 1.93999 10.62 1.93999Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.56 7.30001C11.5467 7.30001 11.5267 7.30001 11.5133 7.30001C9.43333 7.09334 7.76 5.51334 7.44 3.44668C7.4 3.17334 7.58666 2.92001 7.86 2.87334C8.13333 2.83334 8.38666 3.02001 8.43333 3.29334C8.68666 4.90668 9.99333 6.14668 11.62 6.30668C11.8933 6.33334 12.0933 6.58001 12.0667 6.85334C12.0333 7.10668 11.8133 7.30001 11.56 7.30001Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.1667H2C1.72667 15.1667 1.5 14.94 1.5 14.6667C1.5 14.3933 1.72667 14.1667 2 14.1667H14C14.2733 14.1667 14.5 14.3933 14.5 14.6667C14.5 14.94 14.2733 15.1667 14 15.1667Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/Edit-2.0048fb9b.svg";
export { ForwardRef as ReactComponent };